import ShimmerScreen from "../../../Layouts/ShimmerScreen"
import "./DetailPageTitleComponent.scss"

const DetailPageTitleComponent = ({ title, isLoading }) => {
    return (
        <>
        {
            isLoading ?
            <ShimmerScreen 
                case="rect"
                width="60%"
                height="3rem"
            />
            :
            <div className="page-title"
                dangerouslySetInnerHTML={{
                    __html: title
                }}
            >
            </div>
        }
        </>
    )
}

export default DetailPageTitleComponent